// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"b0efe712","494":"1b555f1c","680":"1b555f1c"}[chunkId] + ".chunk.css";
};